import { createAsyncThunk } from '@reduxjs/toolkit';
import { getLeaderboardConfigRest } from './leaderboards-service';
import { LeaderboardOverview } from '@repo/common-types';

export const fetchLeaderboardOverview = createAsyncThunk<LeaderboardOverview>(
  'leaderboards/fetchLeaderboardOverview',
  async () => getLeaderboardConfigRest(),
);
